(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bge-closing"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form         = document.getElementById('qg-bgeclose-form');
  var btn          = document.getElementById('qg-bgeclose-btn');
  var variantInput = document.getElementById('qg-bgeclose-variant-id');
  var priceEl      = form ? form.parentElement.querySelector('.qg-bgeclose__price') : null;
  var labelEl      = btn ? btn.querySelector('.qg-bgeclose__cta-label') : null;
  var variantBtns  = document.querySelectorAll('[data-qg-bgeclose-variant-id]');
  var idleText     = labelEl ? labelEl.textContent : 'Add to cart';
  var resetTimer;

  variantBtns.forEach(function (vbtn) {
    vbtn.addEventListener('click', function () {
      var soldOut = vbtn.classList.contains('is-sold-out');
      if (variantInput) variantInput.value = vbtn.dataset.qgBgecloseVariantId;
      var vprice = vbtn.dataset.qgBgecloseVariantPrice || '';
      if (priceEl && vprice) priceEl.textContent = vprice;
      if (btn) { btn.disabled = soldOut; btn.setAttribute('aria-disabled', soldOut ? 'true' : 'false'); }
      if (labelEl) labelEl.textContent = soldOut ? 'Sold out' : 'Add to cart · ' + vprice;
      idleText = labelEl ? labelEl.textContent : idleText;
      variantBtns.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
      vbtn.classList.add('is-active');
      vbtn.setAttribute('aria-pressed', 'true');
      /* Keep the sticky cart bar (and nav CTA) in sync with whatever variant
         was just picked down here, so every add-to-cart control on the page
         agrees on which item is selected. */
      document.dispatchEvent(new CustomEvent('qg:variant:change', {
        detail: {
          id: parseInt(vbtn.dataset.qgBgecloseVariantId, 10),
          price: vprice,
          available: !soldOut
        }
      }));
    });
  });

  function updateCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.removeAttribute('hidden');
          else el.setAttribute('hidden', '');
        });
      })
      .catch(function () {});
  }

  if (!form || !btn) return;
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var vid = variantInput ? parseInt(variantInput.value, 10) : 0;
    if (!vid || btn.disabled) return;
    clearTimeout(resetTimer);
    btn.disabled = true;
    if (labelEl) labelEl.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Could not add to cart.'); });
        return r.json();
      })
      .then(function () {
        if (labelEl) labelEl.textContent = 'Added ✓';
        updateCartCount();
        document.dispatchEvent(new CustomEvent('qg:cart:added'));
        resetTimer = setTimeout(function () {
          if (labelEl) labelEl.textContent = idleText;
          btn.disabled = false;
        }, 2000);
      })
      .catch(function (err) {
        if (labelEl) labelEl.textContent = idleText;
        btn.disabled = false;
        console.warn('[QG BGE closing] cart add failed:', err.message);
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bge-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* The quicknav "Full spec sheet" pill (and the hero's own deep links) jump
     straight to the <details id="bge-specs"> accordion. A same-page anchor
     jump only scrolls the summary into view - it doesn't open a closed
     <details> - so without this, the click looks like nothing happened. */
  var specs = document.getElementById('bge-specs');
  if (!specs) return;

  function openIfTargeted() {
    if (window.location.hash === '#bge-specs') specs.open = true;
  }

  openIfTargeted();
  window.addEventListener('hashchange', openIfTargeted);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bge-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  var variantBtns  = document.querySelectorAll('[data-qg-bge-variant-id]');
  var variantInput = document.getElementById('qg-bge-variant-id');
  var priceEl      = document.querySelector('.qg-bge__price');
  var btn          = document.getElementById('qg-bge-btn');
  var labelEl      = btn ? btn.querySelector('.qg-bge__cta-label') : null;

  variantBtns.forEach(function (vbtn) {
    vbtn.addEventListener('click', function () {
      var soldOut = vbtn.classList.contains('is-sold-out');
      if (variantInput) variantInput.value = vbtn.dataset.qgBgeVariantId;
      if (priceEl && vbtn.dataset.qgBgeVariantPrice) priceEl.textContent = vbtn.dataset.qgBgeVariantPrice;
      if (btn) { btn.disabled = soldOut; btn.setAttribute('aria-disabled', soldOut ? 'true' : 'false'); }
      if (labelEl) labelEl.textContent = soldOut ? 'Sold out' : 'Add to cart';
      variantBtns.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
      vbtn.classList.add('is-active');
      vbtn.setAttribute('aria-pressed', 'true');
      /* Tell the sticky cart bar (and any other CTA on the page, e.g. nav)
         which variant is now selected, so a click anywhere else on the page
         adds the same item the shopper just picked here. */
      document.dispatchEvent(new CustomEvent('qg:variant:change', {
        detail: {
          id: parseInt(vbtn.dataset.qgBgeVariantId, 10),
          price: vbtn.dataset.qgBgeVariantPrice,
          available: !soldOut
        }
      }));
    });
  });

  var form     = document.getElementById('qg-bge-form');
  var idleText = labelEl ? labelEl.textContent : 'Add to cart';
  var resetTimer;

  function updateCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.removeAttribute('hidden');
          else el.setAttribute('hidden', '');
        });
      })
      .catch(function () {});
  }

  if (!form || !btn) return;
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var vid = variantInput ? parseInt(variantInput.value, 10) : 0;
    if (!vid || btn.disabled) return;
    clearTimeout(resetTimer);
    btn.disabled = true;
    if (labelEl) labelEl.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Could not add to cart.'); });
        return r.json();
      })
      .then(function () {
        if (labelEl) labelEl.textContent = 'Added ✓';
        updateCartCount();
        document.dispatchEvent(new CustomEvent('qg:cart:added'));
        resetTimer = setTimeout(function () {
          if (labelEl) labelEl.textContent = idleText;
          btn.disabled = false;
        }, 2000);
      })
      .catch(function (err) {
        if (labelEl) labelEl.textContent = idleText;
        btn.disabled = false;
        console.warn('[QG BGE] cart add failed:', err.message);
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-buy"] && !Shopify.designMode) return;
  try {
    
/* Gallery readout, quantity stepper, video mute.
   Enhancement only, and it builds no interface. The gallery is a CSS
   scroll-snap track that already swipes, the dots are already anchor links
   rendered in the markup, the quantity is already 1, and add-to-cart is
   already wired - sticky-cart.liquid owns that. All this adds is the "2 / 4"
   readout, the active dot after a swipe, and the video's mute button. */
(function () {
  function initGallery(root) {
    var track = root.querySelector('#qg-counter-track');
    var dots  = root.querySelector('#qg-counter-dots');
    var count = root.querySelector('#qg-counter-count');
    if (!track) return;

    var slides = track.querySelectorAll('.qg-counter__slide');
    if (slides.length < 2) return;

    var dotEls = dots ? dots.querySelectorAll('.qg-counter__dot') : [];

    function sync() {
      /* Derived from scroll position rather than accumulated from events, so a
         fast flick can never leave the readout disagreeing with what is on
         screen. */
      var index = Math.round(track.scrollLeft / track.clientWidth);
      if (index < 0) index = 0;
      if (index > slides.length - 1) index = slides.length - 1;

      if (count) count.textContent = (index + 1) + ' / ' + slides.length;
      for (var i = 0; i < dotEls.length; i++) {
        dotEls[i].setAttribute('aria-current', i === index ? 'true' : 'false');
      }
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; sync(); });
    }, { passive: true });

    for (var d = 0; d < dotEls.length; d++) {
      dotEls[d].addEventListener('click', function (e) {
        e.preventDefault();
        var target = root.querySelector(this.getAttribute('href'));
        if (!target) return;
        track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    }

    window.addEventListener('resize', sync);
    sync();
  }

  function initStepper(root) {
    var MAX = 10;
    var val   = root.querySelector('#qg-counter-qty');
    var input = root.querySelector('#qg-counter-qty-input');
    var dec   = root.querySelector('[data-qg-counter-dec]');
    var inc   = root.querySelector('[data-qg-counter-inc]');
    if (!val || !dec || !inc) return;

    function set(next) {
      var q = Math.min(MAX, Math.max(1, next));
      val.textContent = q;
      /* The hidden input is what the express checkout button posts; the shared
         [data-qg-add] handler reads the visible counter instead. Both have to
         move together or Buy-it-now and Add-to-cart disagree. */
      if (input) input.value = q;
      dec.disabled = q <= 1;
      inc.disabled = q >= MAX;
    }

    dec.addEventListener('click', function () { set(parseInt(val.textContent, 10) - 1); });
    inc.addEventListener('click', function () { set(parseInt(val.textContent, 10) + 1); });
    document.addEventListener('qg:cart:added', function () { set(1); });
    set(1);
  }

  function initVideo(root) {
    var video  = root.querySelector('#qg-counter-video');
    var toggle = root.querySelector('#qg-counter-mute');
    if (!video || !toggle) return;

    var iconOff = toggle.querySelector('[data-state="off"]');
    var iconOn  = toggle.querySelector('[data-state="on"]');

    toggle.addEventListener('click', function () {
      var willUnmute = video.muted;
      video.muted = !willUnmute;
      if (willUnmute) video.play().catch(function () {});
      toggle.setAttribute('aria-pressed', willUnmute ? 'true' : 'false');
      toggle.setAttribute('aria-label', willUnmute ? 'Mute demo video' : 'Unmute demo video');
      if (iconOff) iconOff.hidden = willUnmute;
      if (iconOn)  iconOn.hidden  = !willUnmute;
    });
  }

  function initAll() {
    var roots = document.querySelectorAll('.qg-counter');
    for (var i = 0; i < roots.length; i++) {
      initGallery(roots[i]);
      initStepper(roots[i]);
      initVideo(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-close"] && !Shopify.designMode) return;
  try {
    
/* Quantity stepper. Owns the counter only - the add-to-cart button reads it by
   id via data-qg-qty-source, so all cart submission stays in sticky-cart.js. */
(function () {
  var MAX = 10;

  function init(root) {
    var val = root.querySelector('#qg-close-qty');
    var dec = root.querySelector('[data-qg-qty-dec]');
    var inc = root.querySelector('[data-qg-qty-inc]');
    if (!val || !dec || !inc) return;

    function set(next) {
      var q = Math.min(MAX, Math.max(1, next));
      val.textContent = q;
      dec.disabled = q <= 1;
      inc.disabled = q >= MAX;
    }

    dec.addEventListener('click', function () { set(parseInt(val.textContent, 10) - 1); });
    inc.addEventListener('click', function () { set(parseInt(val.textContent, 10) + 1); });

    /* A successful add empties the intent - leaving "3" on screen invites
       adding three more on the next click. */
    document.addEventListener('qg:cart:added', function () { set(1); });

    set(1);
  }

  function initAll() {
    var nodes = document.querySelectorAll('.qg-close');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-subnav"] && !Shopify.designMode) return;
  try {
    
/* Scroll-spy for the section rail.
   Enhancement only: with this absent every link still navigates, the first
   one just stays highlighted.

   Position is derived from the sections' own bounding boxes on scroll rather
   than accumulated from IntersectionObserver records. IO delivers batched
   entries in observation order, not document order, so a fast flick past
   three sections can leave the highlight on whichever record happened to be
   last in the array - the same failure the feature sequence hit before it
   moved to reading scroll position directly. */
(function () {
  function init() {
    var rail = document.getElementById('qg-subnav');
    if (!rail || rail.dataset.qgReady === '1') return;

    var links = rail.querySelectorAll('[data-qg-subnav-link]');
    if (!links.length) return;

    var targets = [];
    for (var i = 0; i < links.length; i++) {
      var id = links[i].getAttribute('href').slice(1);
      var el = document.getElementById(id);
      if (el) targets.push({ link: links[i], el: el });
    }
    if (!targets.length) return;

    rail.dataset.qgReady = '1';

    var ticking = false;

    function measure() {
      ticking = false;

      /* The line just below both sticky rails is what the visitor is actually
         reading, so that is the line a section has to have crossed to count as
         current - not the top of the viewport, which is behind the rails. */
      var line = rail.getBoundingClientRect().bottom + 1;
      var active = 0;

      for (var i = 0; i < targets.length; i++) {
        if (targets[i].el.getBoundingClientRect().top <= line) active = i;
      }

      for (var j = 0; j < targets.length; j++) {
        if (j === active) {
          targets[j].link.setAttribute('aria-current', 'true');
        } else {
          targets[j].link.removeAttribute('aria-current');
        }
      }

      /* Keep the active chip in view when the rail is scrolled horizontally on
         a phone, or the highlight ends up off-screen and the rail looks inert. */
      var chip = targets[active].link;
      var track = chip.parentElement;
      if (track && track.scrollWidth > track.clientWidth) {
        var left = chip.offsetLeft - track.clientWidth / 2 + chip.offsetWidth / 2;
        track.scrollTo({ left: left, behavior: 'auto' });
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(measure);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    measure();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  var form = document.getElementById('qg-cart-form');
  if (!form) return;

  /* Matches the nav drawer's formatter so the two cart surfaces never show
     the same total two different ways. */
  function money(cents) {
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  function post(line, quantity) {
    form.setAttribute('data-busy', '');

    fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body:    JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Removing a line renumbers every line after it, so patching the DOM
           by hand would desync the line indices from Shopify's. A reload is
           the only cheap way to stay correct. */
        if (quantity === 0 || cart.item_count === 0) {
          window.location.reload();
          return;
        }

        var subtotal = document.querySelector('[data-cart-subtotal]');
        if (subtotal) subtotal.textContent = money(cart.total_price);

        document.dispatchEvent(new CustomEvent('qg:cart:updated', { detail: cart }));
        form.removeAttribute('data-busy');
      })
      .catch(function () {
        form.removeAttribute('data-busy');
        window.location.reload();
      });
  }

  form.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;

    var line = input.closest('[data-cart-line]');
    if (!line) return;

    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;

    post(parseInt(line.dataset.cartLine, 10), qty);
  });

  form.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (!remove) return;

    var line = remove.closest('[data-cart-line]');
    if (!line) return;

    e.preventDefault();
    post(parseInt(line.dataset.cartLine, 10), 0);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* ── Thumbnail switcher ─────────────────────────────────────────────────── */
  var mainImg   = document.getElementById('qg-pdp-main-img');
  var thumbBtns = document.querySelectorAll('[data-qg-thumb-src]');
  thumbBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = btn.dataset.qgThumbSrc;
      thumbBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  /* ── Variant selector ───────────────────────────────────────────────────── */
  var variantBtns  = document.querySelectorAll('[data-qg-variant-id]');
  var variantInput = document.getElementById('qg-pdp-variant-id');
  var priceEl      = document.getElementById('qg-pdp-price');
  var variantName  = document.getElementById('qg-pdp-variant-name');
  var pdpBtn       = document.getElementById('qg-pdp-btn');
  var pdpLabel     = pdpBtn ? pdpBtn.querySelector('.qg-pdp__cta-label') : null;

  variantBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var soldOut = btn.classList.contains('is-sold-out');
      if (variantInput) variantInput.value = btn.dataset.qgVariantId;
      if (priceEl && btn.dataset.qgVariantPrice) priceEl.textContent = btn.dataset.qgVariantPrice;
      if (variantName && btn.dataset.qgVariantName) variantName.textContent = btn.dataset.qgVariantName;
      if (pdpBtn) {
        pdpBtn.disabled = soldOut;
        pdpBtn.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
      }
      if (pdpLabel) pdpLabel.textContent = soldOut ? 'Sold out' : 'Add to cart';
      variantBtns.forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
    });
  });

  /* ── Quantity stepper ───────────────────────────────────────────────────── */
  var qtyInput   = document.getElementById('qg-pdp-qty');
  var qtyValEl   = document.getElementById('qg-pdp-qty-val');
  var qtyDec     = document.getElementById('qg-pdp-qty-dec');
  var qtyInc     = document.getElementById('qg-pdp-qty-inc');

  function setQty(n) {
    if (n < 1) n = 1;
    if (qtyInput)   qtyInput.value        = n;
    if (qtyValEl)   qtyValEl.textContent  = n;
    if (qtyDec)     qtyDec.disabled       = n <= 1;
  }

  if (qtyDec) qtyDec.addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) - 1); });
  if (qtyInc) qtyInc.addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) + 1); });
  setQty(1);

  /* ── Cart add ───────────────────────────────────────────────────────────── */
  var form    = document.getElementById('qg-pdp-form');
  var btn     = document.getElementById('qg-pdp-btn');
  var labelEl = btn ? btn.querySelector('.qg-pdp__cta-label') : null;
  var idleText = labelEl ? labelEl.textContent : 'Add to cart';
  var resetTimer;

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) { el.removeAttribute('hidden'); }
          else { el.setAttribute('hidden', ''); }
        });
      })
      .catch(function () {});
  }

  if (!form || !btn) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var vid      = variantInput ? parseInt(variantInput.value, 10) : 0;
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    if (!vid || btn.disabled) return;
    clearTimeout(resetTimer);
    btn.disabled = true;
    if (labelEl) labelEl.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ id: vid, quantity: quantity })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Could not add to cart.'); });
        return r.json();
      })
      .then(function () {
        if (labelEl) labelEl.textContent = 'Added ✓';
        updateCartCount();
        document.dispatchEvent(new CustomEvent('qg:cart:added'));
        resetTimer = setTimeout(function () {
          if (labelEl) labelEl.textContent = idleText;
          btn.disabled = false;
        }, 2000);
      })
      .catch(function (err) {
        if (labelEl) labelEl.textContent = idleText;
        btn.disabled = false;
        console.warn('[QG PDP] cart add failed:', err.message);
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nav"]) return;
  try {
    
/* ─── Mobile menu ─────────────────────────────────────────────────────────── */
(function () {
  var btn      = document.getElementById('qg-menu-btn');
  var overlay  = document.getElementById('qg-menu-overlay');
  var backdrop = document.getElementById('qg-menu-bd');
  if (!btn || !overlay) return;

  var panel = overlay.querySelector('.qg-menu__panel');

  function openMenu() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    btn.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    btn.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  btn.addEventListener('click', function () {
    overlay.classList.contains('is-open') ? closeMenu() : openMenu();
  });
  if (backdrop) backdrop.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeMenu();
  });
  /* Close after tapping any menu link so same-page anchors aren't left hidden
     behind the panel, and so the cart drawer (opened by [data-qg-add]) is visible. */
  if (panel) {
    panel.addEventListener('click', function (e) {
      if (e.target.closest('a')) closeMenu();
    });
  }
})();

/* ─── Search overlay (predictive search - locked /reference implementation) ── */
(function () {
  var openBtn  = document.getElementById('qg-search-btn');
  var overlay  = document.getElementById('qg-search-overlay');
  var backdrop = document.getElementById('qg-search-bd');
  var input    = document.getElementById('qg-search-input');
  var results  = document.getElementById('qg-search-results');
  var closeBtn = document.getElementById('qg-search-close');

  if (!openBtn || !overlay || !input || !results) return;

  var debounceTimer;
  var lastQuery = '';

  function esc(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function openSearch() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { input.focus(); }, 40);
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    openBtn.focus();
  }

  function renderProducts(products, query) {
    if (!products || !products.length) {
      results.innerHTML = '<li class="qg-search__status">No products found for \u201c' + esc(query) + '\u201d</li>';
      return;
    }
    var html = products.map(function (p) {
      var thumb = (p.featured_image && p.featured_image.url)
        ? '<img class="qg-search__result-thumb" src="' + esc(p.featured_image.url) + '" alt="" width="44" height="44" loading="eager" decoding="async">'
        : '<span class="qg-search__result-thumb--empty" aria-hidden="true"></span>';
      return (
        '<li role="option"><a href="' + esc(p.url) + '" class="qg-search__result-link">' +
          thumb +
          '<span class="qg-search__result-meta">' +
            '<span class="qg-search__result-title">' + esc(p.title) + '</span>' +
            (p.price ? '<span class="qg-search__result-price">' + esc(p.price) + '</span>' : '') +
          '</span>' +
        '</a></li>'
      );
    }).join('');
    html += '<li><a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="qg-search__all-link">See all results for \u201c' + esc(query) + '\u201d \u2192</a></li>';
    results.innerHTML = html;
  }

  function doSearch(query) {
    query = query.trim();
    if (query === lastQuery) return;
    lastQuery = query;
    if (!query) { results.innerHTML = ''; return; }
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=5', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = data && data.resources && data.resources.results && data.resources.results.products;
        renderProducts(products || [], query);
      })
      .catch(function () {
        results.innerHTML = '<li><a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="qg-search__all-link">Search for \u201c' + esc(query) + '\u201d \u2192</a></li>';
      });
  }

  openBtn.addEventListener('click', openSearch);
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  if (backdrop) backdrop.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
  });
  input.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () { doSearch(input.value); }, 280);
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      var q = input.value.trim();
      if (q) window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
    }
  });
})();

/* ─── Cart drawer (locked /reference implementation) ──────────────────────── */
(function () {
  var drawer   = document.getElementById('qg-cart-drawer');
  var backdrop = document.getElementById('qg-cart-backdrop');
  var closeBtn = document.getElementById('qg-cart-close');
  var openBtn  = document.getElementById('qg-cart-btn');
  var bodyEl   = document.getElementById('qg-cart-body');

  if (!drawer || !bodyEl) return;

  function esc(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function money(cents) {
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  function updateBadge(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      n > 0 ? el.removeAttribute('hidden') : el.setAttribute('hidden', '');
    });
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    fetchAndRender();
    setTimeout(function () {
      var panel = drawer.querySelector('.qg-cart-drawer__panel');
      if (panel) panel.focus();
    }, 50);
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (openBtn) openBtn.focus();
  }

  function fetchAndRender() {
    bodyEl.innerHTML = '<p class="qg-cart-loading">Loading\u2026</p>';
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {
        bodyEl.innerHTML = '<p class="qg-cart-loading">Could not load cart.</p>';
      });
  }

  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body:    JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateBadge(cart.item_count); renderCart(cart); })
      .catch(fetchAndRender);
  }

  function renderCart(cart) {
    updateBadge(cart.item_count);

    if (!cart.items || !cart.items.length) {
      bodyEl.innerHTML =
        '<div class="qg-cart-empty">' +
          '<p class="qg-cart-empty__msg">Your cart is empty.</p>' +
          '<a href="/" class="qg-cart-empty__link">Continue shopping \u2192</a>' +
        '</div>';
      return;
    }

    var itemsHtml = cart.items.map(function (item) {
      var img = (item.featured_image && item.featured_image.url)
        ? '<img class="qg-cart-item__img" src="' + esc(item.featured_image.url) + '" alt="" width="64" height="64" loading="lazy">'
        : '<span class="qg-cart-item__img--empty" aria-hidden="true"></span>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="qg-cart-item__variant">' + esc(item.variant_title) + '</p>' : '';
      return (
        '<li class="qg-cart-item">' +
          img +
          '<div class="qg-cart-item__info">' +
            '<p class="qg-cart-item__title">' + esc(item.product_title) + '</p>' +
            variant +
            '<p class="qg-cart-item__price">' + money(item.final_line_price) + '</p>' +
          '</div>' +
          '<div class="qg-cart-item__actions">' +
            '<div class="qg-cart-qty">' +
              '<button class="qg-cart-qty__btn" data-key="' + esc(item.key) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">\u2212</button>' +
              '<span class="qg-cart-qty__val">' + item.quantity + '</span>' +
              '<button class="qg-cart-qty__btn" data-key="' + esc(item.key) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button class="qg-cart-item__remove" data-key="' + esc(item.key) + '" data-qty="0" aria-label="Remove ' + esc(item.product_title) + '">Remove</button>' +
          '</div>' +
        '</li>'
      );
    }).join('');

    bodyEl.innerHTML =
      '<ul class="qg-cart-items">' + itemsHtml + '</ul>' +
      '<div class="qg-cart-foot">' +
        '<div class="qg-cart-foot__subtotal">' +
          '<span class="qg-cart-foot__label">Subtotal</span>' +
          '<span class="qg-cart-foot__amount">' + money(cart.total_price) + '</span>' +
        '</div>' +
        '<p class="qg-cart-foot__note">Shipping &amp; taxes calculated at checkout</p>' +
        '<a href="/checkout" class="qg-cart-foot__checkout">Checkout</a>' +
        '<a href="/cart" class="qg-cart-foot__view-cart">View full cart</a>' +
      '</div>';

    bodyEl.querySelectorAll('[data-key][data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeQty(btn.dataset.key, parseInt(btn.dataset.qty, 10));
      });
    });
  }

  if (openBtn)  openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  /* Open drawer automatically after a successful add-to-cart */
  document.addEventListener('qg:cart:added', openDrawer);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-cart"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar      = document.getElementById('buy');
  var form     = document.getElementById('qg-buy-form');
  var btn      = document.getElementById('qg-buy-btn');
  var feedback = document.getElementById('qg-buy-feedback');

  var priceEl  = bar ? bar.querySelector('.qg-buy__price') : null;
  var labelEl  = btn ? btn.querySelector('.qg-buy__btn-label') : null;
  var idleText = labelEl ? labelEl.textContent : 'Add to cart';
  var resetTimer;

  /* Any product page can have its own variant-picker (hero, closing buy
     block, etc.) that lives outside this section. Rather than duplicate
     variant state, every picker dispatches this event on change and this
     bar - the thing that actually owns the add-to-cart submission - stays
     in sync. Without this, picking a variant elsewhere on the page and then
     clicking the persistent bar would add the wrong item. */
  document.addEventListener('qg:variant:change', function (e) {
    if (!bar || !e.detail) return;
    if (e.detail.id) bar.dataset.variantId = e.detail.id;
    if (priceEl && e.detail.price) priceEl.textContent = e.detail.price;
    var soldOut = e.detail.available === false;
    if (btn) { btn.disabled = soldOut; btn.setAttribute('aria-disabled', soldOut ? 'true' : 'false'); }
    if (labelEl) labelEl.textContent = soldOut ? 'Sold out' : idleText;
  });

  function showFeedback(msg) {
    if (!feedback) return;
    feedback.textContent = msg;
    setTimeout(function () { feedback.textContent = ''; }, 4000);
  }

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) {
            el.removeAttribute('hidden');
          } else {
            el.setAttribute('hidden', '');
          }
        });
      })
      .catch(function () {});
  }

  function addToCart(quantity) {
    if (!bar) return;
    var variantId = parseInt(bar.dataset.variantId, 10);
    if (!variantId) return;
    if (btn && btn.disabled) return;

    var qty = parseInt(quantity, 10);
    if (!qty || qty < 1) qty = 1;

    clearTimeout(resetTimer);
    if (btn) btn.disabled = true;
    if (labelEl) labelEl.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error(data.description || 'Could not add to cart.');
          });
        }
        return res.json();
      })
      .then(function () {
        if (labelEl) labelEl.textContent = 'Added ✓';
        updateCartCount();
        document.dispatchEvent(new CustomEvent('qg:cart:added'));
        resetTimer = setTimeout(function () {
          if (labelEl) labelEl.textContent = idleText;
          if (btn) btn.disabled = false;
        }, 2000);
      })
      .catch(function (err) {
        if (labelEl) labelEl.textContent = idleText;
        if (btn) btn.disabled = false;
        showFeedback(err.message || 'Something went wrong. Please try again.');
      });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart();
    });
  }

  /* All [data-qg-add] buttons (hero, nav, close) route through addToCart().
     A button may name an element holding the quantity via data-qg-qty-source;
     without one it adds a single unit, which is right for the nav and hero
     pills that have no quantity control of their own. */
  document.querySelectorAll('[data-qg-add]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();

      var qty = 1;
      var sourceId = el.getAttribute('data-qg-qty-source');
      if (sourceId) {
        var source = document.getElementById(sourceId);
        if (source) qty = parseInt(source.value || source.textContent, 10);
      }

      addToCart(qty);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
